/**
 * DiscoverPage Component
 */

import { replaceQueue } from '../../../../redux/actions/player';
import { getPlayerTracksFromResults } from '../../../../redux/helpers/player';
import { EmptyStateFragment } from '../../../../relay/emptyState';
import './styles.scss';

import { concat } from 'lodash';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { createFragmentContainer } from 'react-relay';

import Page from '../../../../containers/Page';
import BlogPosts from '../../../organisms/content/BlogPosts';
import Charts from '../../../organisms/content/Charts';
import Collections from '../../../organisms/content/Collections';
import FeaturedArtistList from '../../../organisms/content/FeaturedArtists';
import HeaderPosts from '../../../organisms/content/HeaderPosts';
import NewsletterPromo from '../../../organisms/content/NewsletterPromo';
import SearchArea from '../../../organisms/content/SearchArea';
import StaffPicks from '../../../organisms/content/StaffPicks';

export const DiscoverPagePath = '/browse';

interface IOwnDispatchProps {
  setPlayerQueue: (tracks: IPlayerTrack[]) => void;
}

interface IOwnProps {
  viewer: GQL.IViewer;
  withCarousel?: boolean;
  isUserLoggedIn: boolean;
}

type DiscoverPageProps = IOwnProps & IOwnDispatchProps;

const defaultList = [];

class DiscoverPage extends React.Component<DiscoverPageProps, any> {

  componentDidMount() {
    const data = this.props.viewer.home_page!;
    const allTracks = concat(
      data.featured_artist_tracks || defaultList,
      data.featured_tracks || defaultList,
      ...(data.track_charts || defaultList).map(({ items }) => items || defaultList),
    );
    this.props.setPlayerQueue(getPlayerTracksFromResults(allTracks));
  }

  render() {
    const data = this.props.viewer.home_page!;
    const headerPosts = data.header_posts || defaultList;
    const featuredTerms = data.featured_terms || defaultList;
    const staffPicks = data.featured_tracks || defaultList;
    const featuredArtists = data.featured_artist_tracks || defaultList;
    const featuredCollections = data.featured_collections || defaultList;
    const charts = data.track_charts || defaultList;
    const blogPosts = data.blog_posts || defaultList;

    return (
      <Page id="discover" layout="loose">
        <Helmet>
          <title>Discover</title>
        </Helmet>
        {/*{this.props.hasValidLicense && <LicenseBar />} */}
        <div className="page__main">
          {/*{!this.props.hasValidLicense && (
            <div {...classes('welcome-license') }>
              <div {...classes('welcome-license__content-wrapper') }>
                <VelocityTransitionGroup
                  component="div"
                  enter={{ animation: 'transition.slideUpIn', stagger: 150 }}
                  runOnMount
                  {...classes('welcome-license__content') }
                >
                  <Heading is="h6">Welcome to Bopper</Heading>
                  <Heading is="h2" {...classes('welcome-license__title') }>
                    Build your license now and instantly display&nbsp;prices.
                  </Heading>
                  <LicenseBuilderButton
                    label="Build Your License"
                    size="medium"
                    colorScheme="accent"
                    variant="pill"
                    icon={<IconTerms />}
                    initScopeOnClick
                    {...classes('welcome-license__cta') }
                  />
                </VelocityTransitionGroup>
              </div>
            </div>
          )}
          */}
          {this.props.withCarousel && <HeaderPosts data={headerPosts} />}
          <SearchArea data={featuredTerms} />
          <StaffPicks tracks={staffPicks} withBackground />
          <FeaturedArtistList data={featuredArtists} />
          <BlogPosts data={blogPosts} />
          <Collections data={featuredCollections} />
          <NewsletterPromo isUserLoggedIn={this.props.isUserLoggedIn}/>
          <Charts data={charts} />
        </div>
      </Page>
    );
  }
}

const ConnectedDiscoverPage = connect<{}, IOwnDispatchProps, IOwnProps, IStoreState>(
  ({ user }) => ({
    isUserLoggedIn: user.isLoggedIn,
  }),
  (dispatch) => ({
    setPlayerQueue: (tracks) => {
      dispatch(replaceQueue({ tracks }));
    },
  }),
)(DiscoverPage);

const RelayDiscoverPage = createFragmentContainer(
  ConnectedDiscoverPage,
  EmptyStateFragment,
);

export default RelayDiscoverPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/browse/Discover/index.tsx